export const PAGE_LAYOUT = 'pageLayout';
